import styled from 'styled-components'

export const ExtraActions = styled.div`
  display: flex;
  align-items: center;
`
